import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';
import { useOutsideClick, useTranslation } from '@pascal/pascal-core';

import { gameService } from '../../services';
import { gameStore } from '../../store/gameStore';
import { autoBetStore } from '../../store/autoBetStore';
import { TranslationKeys } from '../../enums/translationKeys';
import { AUTO_BET_COUNTS, INFINITY_AUTO_BET } from '../../enums/constants';

const handleAutoBetCount = (item) => {
  if (!item) {
    return TranslationKeys.OFF;
  }
  if (item === INFINITY_AUTO_BET) {
    return <i className='icon-infinite' />;
  }
  return item;
};

const AutoBetSection = observer(() => {
  const t = useTranslation();
  const autoBetRef = useRef();
  const [opened, handleClick] = useOutsideClick(autoBetRef);
  const { isBetsClosed } = gameStore;
  const { freeBetEnded } = freeBetStore;
  const { autoBetCount, setAutoBetCount, isPlay, resetAutoBet } = autoBetStore;

  const selectAutoBetCount = useCallback(
    (count) => {
      setAutoBetCount(count);
      if (count) {
        gameService.sendBet();
      }
    },
    [setAutoBetCount]
  );

  useEffect(() => {
    if (freeBetEnded?.id && autoBetCount) {
      resetAutoBet();
    }
  }, [freeBetEnded?.id, autoBetCount]);

  return (
    <div
      ref={autoBetRef}
      onClick={handleClick}
      className={`action-btn-el ${opened ? 'active-dropdown' : ''} ${
        (autoBetCount && isPlay) || isBetsClosed ? 'inactive' : ''
      }`}
    >
      <button
        type='button'
        className='icon-auto-letter action-btn'
        disabled={isBetsClosed || (autoBetCount && isPlay)}
      />
      <div className='action-btn-el-value'>
        <p className='action-dropdown-selected'>
          {autoBetCount ? handleAutoBetCount(autoBetCount) : t(handleAutoBetCount(autoBetCount))}
        </p>
        <ul className='action-dropdown'>
          {AUTO_BET_COUNTS.map((item) => (
            <li
              key={item}
              onClick={() => selectAutoBetCount(item)}
              className={`action-dropdown-el ${autoBetCount === item ? 'active' : ''}`}
            >
              {item ? handleAutoBetCount(item) : t(handleAutoBetCount(item))}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
});

export default AutoBetSection;
